export const SITE_URL="https://topkns.ru"
export const LOGS_URL="https://topkns.ru/logs"
export const VAR_NAMES={
    "fit1":"тэнк1",
    "fit2":"тэнк2",
    "fit3":"тэнк3",
    "fit4":"тэнк4",
    "fit5":"КОС 2500"
}